'use client';
import type { SVGProps } from 'react';
const SvgCheckboxIndeterminate = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19.823 3H4.178A1.18 1.18 0 0 0 3 4.178v15.645A1.18 1.18 0 0 0 4.178 21h15.645A1.18 1.18 0 0 0 21 19.823V4.178A1.18 1.18 0 0 0 19.823 3m-2.573 9a.75.75 0 0 1-.75.75h-9a.75.75 0 1 1 0-1.5h9a.75.75 0 0 1 .75.75"
    />
  </svg>
);
export default SvgCheckboxIndeterminate;
